<script lang="ts">
	import Avatar from '$lib/components/Avatar.svelte'
	import Grid from '$lib/components/Grid.svelte'
	import Player from '$lib/components/Player.svelte'

	export let data

	const userUrl = data.user.website
	const displayUrl = userUrl?.replace(/https?:\/\/w*\.?/, '')

	let avatar = ''
</script>

<svelte:head>
	<title>Scenery - @{data.user.username}</title>
</svelte:head>

<div class="flex justify-center items-center gap-4 m-12">
	<Avatar url={avatar} size="l" username={data.user.username} />
	<div class="leading-5">
		<h2 class="text-2xl">{data.user.realname}</h2>
		<p class="text-gray-500">@{data.user.username}</p>
		{#if userUrl}
			<a href={userUrl} class="website">{displayUrl}</a>
		{/if}
	</div>
</div>

{#if data.items.length}
	<Grid>
		{#each data.items as item (item.public_id)}
			<Player {...item} />
		{/each}
	</Grid>
{/if}
